import React, { useMemo } from "react";
import client from "@culturehq/client";

import { useProfile } from "app/context";
import { useFetch } from "app/hooks";

import DefaultPanel from "components/display/DefaultPanel";

import Announcement from "./featured/Announcement";
import Recognitions from "./featured/Recognitions";
import Surveys from "./featured/Surveys";
import Leaderboard from "./featured/Leaderboard";
import StartTheTrend from "./stories/StartTheTrend";

const queryToOptions = queryString => {
  const { i, d, l, s, cl, cy, p, de, v, co } = queryString;

  return {
    interestIds: i || null,
    companyIds: co || null,
    departmentIds: d || null,
    locationIds: l || null,
    skillIds: s || null,
    clubIds: cl || null,
    classYearIds: cy || null,
    programIds: p || null,
    degreeIds: de || null,
    organizationValueIds: v || null
  };
};

const getWidgets = (announcements, widgetOrder, forYou) => {
  const widgets = [...announcements];

  if (widgetOrder && typeof widgetOrder.recognition === "number") {
    widgets.push({ id: "recognition", position: widgetOrder.recognition });
  }

  if (widgetOrder && typeof widgetOrder.survey === "number") {
    widgets.push({ id: "survey", position: widgetOrder.survey });
  }

  if (forYou && widgetOrder && typeof widgetOrder.leaderboard === "number") {
    widgets.push({ id: "leaderboard", position: widgetOrder.leaderboard });
  }

  if (widgetOrder && typeof widgetOrder.startTrend === "number") {
    widgets.push({ id: "start_trend", position: widgetOrder.startTrend });
  }

  return widgets.sort(({ position: a }, { position: b }) => (a - b));
};

const FeaturedContent = ({ widgets }) => widgets.map(widget => {
  switch (widget.id) {
    case "recognition":
      return <Recognitions key="recognition" />;
    case "survey":
      return <Surveys key="surveys" />;
    case "leaderboard":
      return <Leaderboard key="leaderboard" />;
    case "start_trend":
      return <StartTheTrend key="start_trend" />;
    default:
      return <Announcement key={widget.id} widget={widget} />;
  }
});

const Featured = ({ queryString, forYou }) => {
  const { profile } = useProfile();

  const { fetching, json } = useFetch(
    () => client.listActiveAnnouncements({ forYou, ...queryToOptions(queryString) }),
    [forYou, queryString]
  );
  const { announcements = [] } = json;

  const widgets = useMemo(
    () => getWidgets(announcements, profile.organization.widgetOrder, forYou),
    [announcements, profile, forYou]
  );

  if (fetching) {
    return [1, 2, 3].map(i => <DefaultPanel key={i} />);
  }

  return (
    <div className="Featured">
      <FeaturedContent widgets={widgets} />
    </div>
  );
};

export default Featured;
